export default __webpack_public_path__ + "static/media/010_home.first.ff9cda3c.avif";